import { brandPrimaryHover } from '../../../../web/styles/colors';
import { DefaultBorder, truncateTextStyle } from '../../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	bold: {
		fontWeight: 600,
	},
	container: {
		':last-child': {
			borderBottom: DefaultBorder,
		},
		borderTop: DefaultBorder,
		padding: '20px 0',
	},
	name: {
		color: brandPrimaryHover,
		fontSize: 18,
		fontWeight: 600,
		minWidth: 400,
		...truncateTextStyle,
	},
	percent: {
		color: '#0C0F11',
		fontSize: 14,
		textAlign: 'left',
		width: 100,
	},
	textContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
});
